import React from "react";
import { IcoWhatsapp } from "./icons";
import { useContato, whatsappLink } from "../../lib/contato";

export default function WhatsAppFab() {
  const contato = useContato();

  return (
    <a
      className="whatsapp-fab"
      href={whatsappLink(contato.whatsapp, contato.whatsappMensagem)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <IcoWhatsapp size={28} />
      <span className="fab-label">{contato.whatsappBotao}</span>
    </a>
  );
}
